import { createRouter, createWebHistory } from "vue-router";
import { useUserStore } from "@/stores/user";
import LoginPage from "@/views/LoginPage.vue";
import DashboardLayout from "@/layouts/DashboardLayout.vue";
import AdminPrefeituraDashboard from "@/views/dashboard/AdminPrefeituraDashboard.vue";
import PrefeituraDashboard from "@/views/dashboard/PrefeituraDashboard.vue";
import AdminFunerariaDashboard from "@/views/dashboard/AdminFunerariaDashboard.vue";
import FunerariaDashboard from "@/views/dashboard/FunerariaDashboard.vue";
import CemiterioDashboard from "@/views/dashboard/CemiterioDashboard.vue";
import UnauthorizedPage from "@/views/UnauthorizedPage.vue";

const routes = [
    { path: "/", name: "Login", component: LoginPage },
    {
        path: "/dashboard",
        name: "Dashboard",
        component: DashboardLayout,
        meta: { requiresAuth: true },
        children: [
            {
                path: "admin-prefeitura",
                name: "AdminPrefeituraDashboard",
                component: AdminPrefeituraDashboard,
                meta: { requiresAuth: true, role: ["admin_prefeitura"] },
            },
            {
                path: "prefeitura",
                name: "PrefeituraDashboard",
                component: PrefeituraDashboard,
                meta: { requiresAuth: true, role: ["prefeitura"] },
            },
            {
                path: "admin-funeraria",
                name: "AdminFunerariaDashboard",
                component: AdminFunerariaDashboard,
                meta: { requiresAuth: true, role: ["admin_funeraria"] },
            },
            {
                path: "funeraria",
                name: "FunerariaDashboard",
                component: FunerariaDashboard,
                meta: { requiresAuth: true, role: ["funeraria"] },
            },
            {
                path: "cemiterio",
                name: "CemiterioDashboard",
                component: CemiterioDashboard,
                meta: { requiresAuth: true, role: ["admin_cemiterio", "cemiterio"] },
            },
        ],
    },
    {
        path: "/unauthorized",
        name: "Unauthorized",
        component: UnauthorizedPage,
    },
];

const router = createRouter({
    history: createWebHistory(),
    routes,
});

router.beforeEach((to, from, next) => {
    const userStore = useUserStore();

    // Ensure the store is initialized (e.g., check auth token)
    if (!userStore.isAuthenticated && userStore.checkAuth) {
        userStore.checkAuth();
    }

    // If navigating to a protected route
    if (to.meta.requiresAuth) {
        if (!userStore.isAuthenticated) {
            return next({ path: "/" }); // Redirect to Login
        }

        // Role-based access control
        if (to.meta.role && !to.meta.role.includes(userStore.role)) {
            return next({ path: "/unauthorized" }); // Redirect to Unauthorized
        }
    }

    // If navigating to Login and already authenticated, redirect based on role
    if (to.name === "Login" && userStore.isAuthenticated) {
        switch (userStore.role) {
            case "admin_prefeitura":
                return next({ name: "AdminPrefeituraDashboard" });
            case "prefeitura":
                return next({ name: "PrefeituraDashboard" });
            case "admin_funeraria":
                return next({ name: "AdminFunerariaDashboard" });
            case "funeraria":
                return next({ name: "FunerariaDashboard" });
            case "admin_cemiterio":
            case "cemiterio":
                return next({ name: "CemiterioDashboard" });
            default:
                return next({ path: "/unauthorized" });
        }
    }

    next();
});

export default router;
